/* Avanti motion (Oct 26): headline reveal, slow image zoom, lazy videos. No libraries. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  window.avMotionReady = true;

  /* Videos load only when near the screen. With reduced motion they stay on their poster image. */
  function loadVideo(v) {
    if (v.dataset.avLoaded) return;
    v.dataset.avLoaded = '1';
    var small = window.innerWidth < 768 && v.dataset.srcMobile;
    var src = small ? v.dataset.srcMobile : v.dataset.src;
    if (!src) return;
    v.src = src;
    if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }

  var revealIO = null, videoIO = null, zoomIO = null, visible = [];
  if (hasIO) {
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    videoIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { loadVideo(v); if (!reduce && v.paused && v.src) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
        else if (v.src && !v.paused) { v.pause(); }
      });
    }, { rootMargin: '200px 0px' });
    if (!reduce) {
      zoomIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var i = visible.indexOf(e.target);
          if (e.isIntersecting && i < 0) visible.push(e.target);
          if (!e.isIntersecting && i > -1) visible.splice(i, 1);
        });
        tick();
      });
    }
  }

  var queued = false;
  function update() {
    queued = false;
    var h = window.innerHeight;
    for (var i = 0; i < visible.length; i++) {
      var el = visible[i], r = el.getBoundingClientRect();
      var p = (h - r.top) / (h + r.height);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      el.style.setProperty('--av-z', (1 + 0.05 * p).toFixed(4));
    }
  }
  function tick() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }

  function init(root) {
    root = root || document;
    var reveals = root.querySelectorAll('.av-reveal:not(.is-in)');
    for (var i = 0; i < reveals.length; i++) {
      if (revealIO && !reduce) revealIO.observe(reveals[i]); else reveals[i].classList.add('is-in');
    }
    var vids = root.querySelectorAll('video[data-src]');
    for (var j = 0; j < vids.length; j++) { if (videoIO) videoIO.observe(vids[j]); else loadVideo(vids[j]); }
    if (zoomIO) {
      var zs = root.querySelectorAll('.av-zoom');
      for (var k = 0; k < zs.length; k++) zoomIO.observe(zs[k]);
    }
  }

  if (zoomIO) { window.addEventListener('scroll', tick, { passive: true }); window.addEventListener('resize', tick); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Theme editor: sections re-render without a page load */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
